<template><TableWlPatients /></template>
<script>
import TableWlPatients from '../patients/TableWlPatients.vue'
export default { name: 'ReportPatients', components: { TableWlPatients } }
</script>
